const State = {
  storageList: []
}

export default State
